import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

import { AppContext } from "../../../context/AppContext"
import ChargerCard from "../ChargerCard/ChargerCard"
import { useMediaQuery } from "react-responsive"
import ChargerList from "../ChargerList/ChargerList"

import styles from "./ChargersMenu.module.scss"

const ChargersMenu = React.forwardRef(({ from}, ref ) => {
  const { store } = useContext(AppContext)
  const { t } = useTranslation()
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const chargersToRender =
  from === 'header'
    ? store.chargers
    : store.chargers.filter(
        charger =>
          !store.selectedSector ||
          charger.sectors.includes(store.selectedSector)
      );

  return (
    <div ref={ref} className={from === 'header' ? `${styles.chargersMenuWrapper} ${styles.chargersMenuHeader}` : styles.chargersMenuWrapper}>
      {from === "header" && <div className={styles.title}>{t("chargers menu home")}</div>}
      {from !== "header" && <div className={styles.title}>{t("chargers menu homeConfigure")}</div>}
      <div
        className={
          from === "header"
            ? `${styles.chargersMenuContainer} ${styles.header}`
            : styles.chargersMenuContainer
        }
      >
        

      {chargersToRender.map(charger =>
        isMobile && from === 'header' ? (
          <ChargerList
            key={charger.code}
            charger={charger}
            compact={from === 'header'}
          />
        ) : (
          <ChargerCard
            key={charger.code}
            charger={charger}
            compact={from === 'header'}
          />
        )
      )}

      </div>
    </div>
  )
})

export default ChargersMenu
